import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { MediaManager } from "@/features/admin/components/media-manager";
import { PageContainer } from "@fleet/ui";

function AdminMediaPage() {
  return (
    <PageContainer maxWidth="5xl">
      <MediaManager />
    </PageContainer>
  );
}

export const adminMediaRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/media",
  validateSearch: (search: Record<string, unknown>): { filter?: "orphaned" } => ({
    filter: search.filter === "orphaned" ? "orphaned" : undefined,
  }),
  component: AdminMediaPage,
});
